
angular.module('v3sWbtPlayerApp').directive('v3sManual', ["v3sManual", function (v3sManual) {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: "app/js/navigation/manual/manual.tpl.html",
        controller: ["$scope", "$element", function ($scope, $element) {
            $scope.manual = v3sManual;
        }]
    }
}]);
